'use client'

import * as React from 'react'
import { Check, X, ListEnd } from 'lucide-react'
import {
  CommandGroup,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@deepguide-ai/ui'

export interface AICompletionCommandsProps {
  completion: string
  onAccept: () => void
  onInsertBelow: () => void
  onDiscard: () => void
  isAppendMode?: boolean
}

export function AICompletionCommands({
  completion,
  onAccept,
  onInsertBelow,
  onDiscard,
  isAppendMode = false,
}: AICompletionCommandsProps) {
  console.log('[AICompletionCommands] Rendering, isAppendMode:', isAppendMode)
  return (
    <CommandList>
      <CommandGroup heading='Apply AI changes'>
        {isAppendMode ? (
          // For append mode (Continue writing), only show "Insert after selection"
          <CommandItem
            value='insert'
            onSelect={onAccept}
            className='flex cursor-pointer gap-2 px-2 py-1.5'
          >
            <Check className='text-muted-foreground h-4 w-4 shrink-0' />
            <div className='flex flex-col'>
              <span className='font-medium'>Insert after selection</span>
            </div>
          </CommandItem>
        ) : (
          // For replace mode, show both Replace and Insert below options
          <>
            <CommandItem
              value='replace'
              onSelect={onAccept}
              className='flex cursor-pointer gap-2 px-2 py-1.5'
            >
              <Check className='text-muted-foreground h-4 w-4 shrink-0' />
              <div className='flex flex-col'>
                <span className='font-medium'>Replace selection</span>
              </div>
            </CommandItem>
            <CommandItem
              value='insert'
              onSelect={onInsertBelow}
              className='flex cursor-pointer gap-2 px-2 py-1.5'
            >
              <ListEnd className='text-muted-foreground h-4 w-4 shrink-0' />
              <div className='flex flex-col'>
                <span className='font-medium'>Insert below</span>
              </div>
            </CommandItem>
          </>
        )}
      </CommandGroup>
      <CommandSeparator />
      <CommandGroup heading='Other options'>
        <CommandItem
          value='discard'
          onSelect={onDiscard}
          className='flex cursor-pointer gap-2 px-2 py-1.5'
        >
          <X className='text-muted-foreground h-4 w-4 shrink-0' />
          <div className='flex flex-col'>
            <span className='font-medium'>Keep original</span>
          </div>
        </CommandItem>
      </CommandGroup>
    </CommandList>
  )
}
